var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaticS(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99764 0C9.31287 0 12 2.6866 12 6.00118C12 9.31576 9.31287 12 6 12C2.68477 12 1.55501e-06 9.3134 1.55501e-06 6.00118C-0.00235972 2.6866 2.68477 0 5.99764 0Z",
    fill: "#8247E5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5041_11415",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 8,
    height: 8
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.889 2.59473H2.0236V9.48593H9.889V2.59473Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5041_11415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96452 4.69384C7.82048 4.61121 7.6363 4.61121 7.47338 4.69384L6.3258 5.37375L5.54658 5.80578L4.42025 6.48333C4.27621 6.56596 4.09203 6.56596 3.9291 6.48333L3.04835 5.94743C2.90431 5.8648 2.80278 5.69955 2.80278 5.5154V4.48609C2.80278 4.32083 2.88542 4.15794 3.04835 4.05406L3.9291 3.5394C4.07314 3.45678 4.25732 3.45678 4.42025 3.5394L5.301 4.07531C5.44504 4.15794 5.54658 4.32319 5.54658 4.50734V5.18725L6.3258 4.73397V4.03517C6.3258 3.86992 6.24315 3.70702 6.08022 3.60315L4.4415 2.63521C4.29746 2.55259 4.11328 2.55259 3.95036 2.63521L2.27149 3.62439C2.10856 3.70702 2.02592 3.87228 2.02592 4.03517V5.96868C2.02592 6.13393 2.10856 6.29683 2.27149 6.40071L3.93147 7.36864C4.0755 7.45127 4.25968 7.45127 4.42261 7.36864L5.54894 6.70997L6.32816 6.2567L7.45449 5.59803C7.59852 5.5154 7.7827 5.5154 7.94563 5.59803L8.82639 6.11269C8.97042 6.19532 9.07196 6.36057 9.07196 6.54472V7.57403C9.07196 7.73929 8.98932 7.90218 8.82639 8.00606L7.96688 8.52071C7.82285 8.60334 7.63867 8.60334 7.47574 8.52071L6.59262 8.00606C6.44858 7.92343 6.34705 7.75817 6.34705 7.57403V6.91536L5.56783 7.36864V8.04855C5.56783 8.21381 5.65047 8.3767 5.8134 8.48058L7.47338 9.44851C7.61741 9.53114 7.80159 9.53114 7.96452 9.44851L9.6245 8.48058C9.76854 8.39795 9.87007 8.23269 9.87007 8.04855V6.0938C9.87007 5.92854 9.78743 5.76565 9.6245 5.66177L7.96452 4.69384Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaticS);
export default __webpack_public_path__ + "static/media/matic-s.12c9e31a0b8e4878af020da59474d0a5.svg";
export { ForwardRef as ReactComponent };